
<template>
  <el-scrollbar wrap-class="scrollbar-wrapper">
    <el-menu
      :show-timeout="200"
      :default-active="decodeURIComponent($route.fullPath)"
      :collapse="isCollapse"
      :background-color="variables.menuBg"
      :text-color="variables.menuText"
      :active-text-color="variables.menuActiveText"
      v-loading="listenSitemap"
      element-loading-background="rgba(48, 65, 86, 0.5)"
      mode="vertical"
			@open="handleOpen"
			@close="handleClose"
    >
		<LogoToggle :showStatus="isCollapse" :logoMsg="logoMsg"></LogoToggle>
		<sidebar-item v-for="sitemap in sitemapList" :key="sitemap.sitemapId" :item="sitemap" :isOpen="isOpen"/>
    </el-menu>
  </el-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex'
import variables from '@/styles/variables.scss'
import SidebarItem from './SidebarItem'
import LogoToggle from '@/components/LogoToggle'

export default {
	name:'Sidebar',
	data () {
		return {
			// 传入 logo 文件名
			logoMsg : {
				logoFileName:'defaultLogo',
				projectName:''
			},
			isOpen: false
		}
	},
	components: {
		SidebarItem,
		LogoToggle
	},
	computed: {
		...mapGetters([
			'sitemapList',
			'sidebar'
		]),
		variables() {
			return variables
		},
		isCollapse() {
			return !this.sidebar.opened
		},
		// 监听菜单状态
		listenSitemap() {
				return !this.$store.state.user.isSitemapInit;
		}
	},
	methods: {
		// 跳转链接
		handleOpen() {
			this.isOpen = true
		},
		handleClose () {
			this.isOpen = false
		}
	}
}
</script>
